import { IRootState } from '../../../store'
import { ICameraAttachmentsOptionsState } from '../store/options.types'

export const getCameraAttachmentsOptionsSelector = (state: IRootState): ICameraAttachmentsOptionsState =>
  state.options.cameraAttachmentsOptions
